import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Loader from '../component/loader'
import MainLayout from '../mainLayout'
import TextField from '../component/TextField'

import CopyIcon from '../icons/copyicon'
import UploadFile from '../component/UploadFile'
import FpgMinusIcon from '../icons/fpgminusicon'
import FpgPlusIcon from '../icons/fpgplusicon'
import TextEditor from '../component/TextEditor'
import SearchIcon from '../icons/searchicon'
import serachIcon from './../assets/images/search.svg'
import HighlightTable from '../component/HighlightTable'
import FpgeeditIcon from '../icons/fpgediticon'
import FpgpublishIcon from '../icons/fpgpublishicon'
import FpgDeleteIcon from '../icons/fpgdeleteicon'
import FpgDisableIcon from '../icons/fpgdisableicon'
import Dropdown from '../component/Dropdown'
import Textarea from '../component/Textarea'
import Cookies from "universal-cookie";
import service from "../services";
import HighlightFhBlock from '../component/HighlightFhBlock';
// Editors
import { EditorState, convertToRaw, ContentState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
//react-dropdown-select
import Select from "react-dropdown-select";
import SearchResults from 'react-filter-search';
//Service import
import ErrorPopUp from '../component/errorPopUp'
import ModalMessage from '../component/ModalMessage'

const cookies = new Cookies();
let sub;
let timer = null;
let selectedVal = ['', '', '', ''];
export default class HighlightsFh extends Component {
    constructor(props) {
        super(props)
        this.apiServe = new service();

        this.state = {
            highLightData: "",
            activetab: 0,
            FeaturedhighLightData: "",
            selectedHighligths: "Select From Below",
            isEdit: false,
            selectdata: [
                {
                    "id": "1",
                    "label": "This Is Not a Burial, It's a Resurrection",
                    "category": "In the Press",
                    "value": "inpress"
                },
                {
                    "id": "2",
                    "label": "It's a Resurrection",
                    "category": "Sundance Hashtag",
                    "value": "hashtag"
                },
                {
                    "id": "3",
                    "label": "Burial, It's a Resurrection",
                    "category": "News",
                    "value": "news"
                }
            ],
            selectedVal : selectedVal,
            headerTitle: '',
            headerSubtitle: EditorState.createEmpty(),
            messageModal: false,
        }

        this.submitHandler = this.submitHandler.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.selectedDropbox = this.selectedDropbox.bind(this);
    }
    TabClick = (index) => {
        this.setState({
            activetab: index
        })
    }

    EditFeatured = () => {
        this.setState({
            isEdit: true,
        })
    }

    // event

    componentWillUnmount = () => {
        sub.unsubscribe();
        clearTimeout(timer);
    };

    // event call
    authentication = () => {
        this.apiServe.sendevent("authentication", {
            token: localStorage.getItem("myLoginToken"),
            role: localStorage.getItem('currentUserRole')
        });
    };

    getProfile = () => {
        this.apiServe.sendevent("user|getProfile", {});
    };
    getFeaturedHighlight = () => {
        this.apiServe.sendevent("homePage|featuredHighlight|getList", {
            "highlightType": ["News", "In The Press", "Stories"],
            "limit": this.loadItem,
            "page": 1
        });
    };

    getFeaturedHighlightTile = () => {
        this.apiServe.sendevent("homePage|featuredHighlightTile|getList", {
            "limit": 10,
            "page": 1
        });
    };

    // select dropbox
    selectedDropbox(val, selectId) {
        try {
            selectedVal[selectId] = val[0]._id;
        
            this.state.highLightData && this.state.highLightData.docs.forEach(element => {
                
                selectedVal.forEach(selEle => {
                    if (selEle != '') {
                        if (selectedVal.includes(element._id)) {
                            element.disabled = true;
                        } else {
                            element.disabled = false;
                        }
                    }
                });
            });
        } catch (error) {
            debugger
            console.log("Error",error)
        }
    }


    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }
    handleChangeTile = (val, selectId) => {
        // this.setState({
            //     tile: []
            // })
            // this.setState({
                //     tile: val,
                //     tile_id: val._id
                // });
        selectedVal[selectId] = val;
        
        this.state.highLightData && this.state.highLightData.docs.forEach(element => {
            
            selectedVal.forEach(selEle => {
                if (selEle != '') {
                    if (selectedVal.includes(element._id)) {
                        element.disabled = true;
                    } else {
                        element.disabled = false;
                    }
                }
            });
        });
        this.setState({
            selectedVal : selectedVal
        })
    };
// submit 
    submitHandler(event) {
        const name = convertToRaw(this.state.headerSubtitle.getCurrentContent())
            const markup = draftToHtml(name)
        this.apiServe.sendevent("homePage|featuredHighlightTile|create", {
            "tileHeaderTitle": this.state.headerTitle,
            "tileHeaderSubtitle": markup,
            "highlightFeaturedTile": [
                {
                    "featuredHighlightId": selectedVal[0].value
                },
                {
                    "featuredHighlightId": selectedVal[1].value
                },
                {
                    "featuredHighlightId": selectedVal[2].value
                },
                {
                    "featuredHighlightId": selectedVal[3].value
                }
            ]
        });

        event.preventDefault();
    }
   
// event
    componentDidMount = () => {
        let particularUser = cookies.get("particularUser");


        if (particularUser && particularUser.token) {
            this.apiServe.sendevent("authentication", {
                token: particularUser.token,
                role: localStorage.getItem('currentUserRole')
            });
        }
        this.getFeaturedHighlightTile();
        this.getFeaturedHighlight();
        sub = this.apiServe.getevent().subscribe((response) => {
            switch (response.event) {

                case "authentication":
                    if (response.error) {
                        localStorage.clear();
                    } else {
                        localStorage.setItem("loggedInUser", response.data.user.role);
                        localStorage.setItem("myLoginToken", response.data.token);
                        this.getProfile();
                    }

                    break;
                case "user|getProfile":
                    if (response.error) {
                    } else {
                        if (localStorage.getItem("myLoginToken")) {
                            let userInfo = {
                                fname: response.data.fname,
                                lname: response.data.lname,
                                image: response.data.image,
                            };
                            localStorage.setItem("Header", JSON.stringify(userInfo));
                        }

                        this.setState({ Header: true });
                        this.forceUpdate();
                    }
                    break;
                case "homePage|featuredHighlight|getList":
                    if (response.error) {
                    } else {
                        this.setState({
                            highLightData: response.data,
                        })
                    }
                    break;
                case "homePage|featuredHighlightTile|getList":
                    if (response.error) {
                    } else {
                        const blocksFromHtml = htmlToDraft(response && response.data && response.data.tileHeaderSubtitle);
                        const { contentBlocks, entityMap } = blocksFromHtml;
                        const contentState = ContentState.createFromBlockArray(
                          contentBlocks,
                          entityMap
                        );
                        const headerSubtitle = EditorState.createWithContent(contentState);
                        this.setState({
                            headerSubtitle: headerSubtitle,
                        });
                        this.setState({
                            FeaturedhighLightData: response.data,
                            headerTitle : response.data.tileHeaderTitle,
                            headerSubTitle : response.data.tileHeaderSubtitle,
                        })
                        response.data.highlightFeaturedTile.forEach((item,i) => {
                            selectedVal[i] = { value: item.featuredHighlightId._id, label: item.featuredHighlightId.highlightTitle, type:item.featuredHighlightId.highlightType }
                        })
                        this.setState({
                            selectedVal : selectedVal
                        })
                    }
                    break;
                case "homePage|featuredHighlightTile|create":
                    if (response.error) {
                        this.setState({
                            errorPopup: true,
                            errorMsg: response.data.error
                        })
                    } else {
                        this.setState({
                            loaderFlag: false
                        });
                        this.apiServe.success('Added Successfully.');
                    }
                    break;
                case "homePage|featuredHighlightTile|getList":
                        if (response.error) {
                        } else {
                            this.setState({
                                FeaturedData: response.data,
                            })
    
                        }
                        break;
                default:
                    break;
            }
        });
    };

    getHomeData = () => {
        this.apiServe.sendevent("homePage|featuredHighlight|getList", {});
        /* timer = setInterval(
           () => this.apiServe.sendevent("FPGHomePage|getSettings", {}),
           5000
         );*/
    };

    SelectHighlight = (e) => {
        var active = e.target.parentNode.closest(".custom_dropdown").querySelector(".select_field").classList.toggle("active");
        var panel = e.target.parentNode.closest(".custom_dropdown").querySelector(".select_content ");
        if (panel && panel.style.maxHeight) {
            panel.style.maxHeight = "";
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    }

    onChange = (e) => {
        let isChecked = e.target.checked;
        let value = e.target.value;
        if (isChecked) {
            this.setState({
                selectedHighligths: e.target.dataset.desc
            })
            document.querySelector(".select_content").style.maxHeight = null;
        }
    }

    onEditorStateChange = (headerSubtitle) => {
        this.setState({
          headerSubtitle,
        });
      };

    render() {

        const {
            highLightData,
            FeaturedhighLightData
        } = this.state;
        return (
            <React.Fragment>
                <div className="ticketing_content  home_content">
                                <div className="ticketing_wrapper fpg_tabcontent">
                                    <form onSubmit={this.submitHandler}>
                                        <div>

                                            <div className="header_col">
                                                <div className="field_row horizontal_field">
                                                    <TextField type="text" name="headerTitle" label="Header Title" value={this.state.headerTitle} onChange={this.handleInputChange} id="uniqueID" />
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    {/* <Textarea label="Header Subtitle" name="headerSubTitle" type="textarea" height="105px" value={this.state.headerSubTitle} onChange={this.handleInputChange} /> */}
                                                    <TextEditor
                                                        name="headerSubtitle"
                                                        editorState={this.state.headerSubtitle}
                                                        value={this.state.headerSubtitle}
                                                        onEditorStateChange={(e) =>
                                                            this.onEditorStateChange(e)
                                                        }
                                                    />
                                                </div>
                                            </div>

                                            <HighlightFhBlock
                                                selectedDropbox={this.selectedDropbox}
                                                handleChangeTile={this.handleChangeTile}
                                                tile={this.state.tile}
                                                selectedVal={this.state.selectedVal}
                                            />

                                        </div>
                                        <div className="text_center field_row w_100 buttons_outer">
                                            <button type="button" className="uppercase">CANCEL</button>
                                            {/* <button type="button" className="uppercase prev_btn">PREviEW</button> */}
                                            <button className="uppercase active" type="submit">SAVE</button>
                                        </div>
                                    </form>
                                </div>
                    </div>


            
                {this.state.messageModal &&
                    <ModalMessage messageModal={this.state.messageModal} withoutEmail="Few or all of the required fields are missing. Please scroll up and check to add and confirm and resubmit" ClosemessageModal={this.ClosemessageModal} />
                }
                {this.state.errorPopup ?
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.errorMsgPopup}
                    />
                    : ''
                }
            </React.Fragment >
        )
    }
}
